import { get, getTrackingString, isProfilePage, isProfilePageEdit } from '../../utils/object-helpers';

const KEY = 'str-seller-card';
const SEL = {
    feedbackLink: '.str-seller-card__feedback-link'
};

export default class {
    onCreate() {
        this.state = {
            isSticky: false,
            drawerOpen: false
        };
    }
    onInput(input) {
        const info = get(input, 'page.modules.PRESENCE_INFORMATION_MODULE', null);
        const followTextSpans = get(info, 'followerDescription.textSpans', []);
        const feedbackTextSpans = get(info, 'feedbackDescription.textSpans', []);
        const soldTextSpans = get(info, 'soldDescription.textSpans', []);
        const contactSellerText = get(input, 'page.modules.CONTACT_SELLER_MODULE.contactAction.text', '');
        const contactSellerLink = get(input, 'page.modules.CONTACT_SELLER_MODULE.contactAction.action.URL', '');
        let contactSeller;
        if (contactSellerText && contactSellerLink) {
            contactSeller = {
                text: contactSellerText,
                link: contactSellerLink
            };
        }

        return {
            headerLogoInput: {
                ...info,
                globalState: input.globalState
            },
            name: {
                text: get(info, 'displayName.textSpans', []),
                link: get(info, 'displayName.action.URL', ''),
                tracking: getTrackingString(info, 'displayName.action.trackingList')
            },
            logo: {
                title: get(info, 'logo.title', ''),
                imageUrl: get(info, 'logo.URL', ''),
                link: get(info, 'logo.action.URL', ''),
                a11y: get(info, 'logo.title', ''),
                tracking: getTrackingString(info, 'logo.action.trackingList')
            },
            editProfileDescriptions: {
                editProfileDescriptionsLine1: get(info, 'editProfileDescriptions.0.textSpans.0.text', ''),
                editProfileDescriptionsLine2: get(info, 'editProfileDescriptions.1.textSpans.0.text', ''),
                profilePageURL: get(info, 'editProfileDescriptions.1.action.URL', ''),
                tracking: getTrackingString(info, 'editProfileDescriptions.1.action.trackingList')
            },
            follow: {
                textSpans: followTextSpans,
                textString: getString(followTextSpans)
            },
            feedback: {
                textSpans: feedbackTextSpans,
                textString: getString(feedbackTextSpans),
                link: get(info, 'feedbackDescription.action.URL', ''),
                tracking: getTrackingString(info, 'feedbackDescription.action.trackingList')
            },
            sold: {
                textSpans: soldTextSpans,
                textString: getString(soldTextSpans)
            },
            isProfilePage: isProfilePage(input.page),
            isProfilePageEdit: isProfilePageEdit(input.page),
            globalState: input.globalState,
            contactSeller: contactSeller,
            page: input.page
        };
    }
    onMount() {
        this.root = this.getEl(KEY);
        if (this.root) {
            const feedbackLink = this.root.querySelector(SEL.feedbackLink);
            if (feedbackLink) {
                feedbackLink.addEventListener('click', (evt) => {
                    evt.preventDefault();
                    const href = evt.target.getAttribute('href');
                    if (href) {
                        const hashIndex = href.indexOf('#');
                        const hash = href.substring(hashIndex);
                        if (hash) {
                            window.location.hash = hash;
                        }
                    }
                });
            }
        }
    }
    openDrawer() {
        this.state.drawerOpen = true;
    }
    closeDrawer() {
        this.state.drawerOpen = false;
    }
}

function getString(textSpans) {
    if (textSpans && textSpans.length) {
        const text = [];
        for (const span of textSpans) {
            text.push(span.text);
        }
        return text.join(' ').trim();
    }
    return '';
}
